import { ComponentProps } from 'react';
import { Alert, Text as TextComponent } from '@qga/roo-ui/components';

export type WarningProps = Omit<ComponentProps<typeof Alert>, 'children'>;

export type NoOfferWarningProps = {
  title: string;
  bodyText: string;
} & WarningProps;

const Text = (props: ComponentProps<typeof TextComponent>) => (
  <TextComponent fontSize="16px" lineHeight="24px" m="0" as="p" {...props} />
);

const BaseWarning = ({ title, bodyText, ...props }: NoOfferWarningProps) => {
  return (
    <Alert
      variant="error"
      mb="0"
      data-testid="WARNING_ALERT"
      backgroundColor="alert.warning"
      {...props}
    >
      <Text mb="1" fontWeight="bold">
        {title}
      </Text>
      <Text color="greys.steel">{bodyText}</Text>
    </Alert>
  );
};

const NoOfferWarning = (props: WarningProps) => {
  return (
    <BaseWarning
      {...props}
      data-testid="NO_OFFER_WARNING_ALERT"
      title="There is no holiday package available."
      bodyText="Try changing your travel dates or travellers."
    />
  );
};

const ChooseOtherOfferWarning = ({
  dealName,
  ...props
}: {
  dealName: string;
} & WarningProps) => {
  return (
    <BaseWarning
      {...props}
      data-testid="OTHER_OFFER_WARNING_ALERT"
      title={`The ${dealName} is unavailable.`}
      bodyText="Try changing your travel dates, travellers or select other available package option."
    />
  );
};

BaseWarning.NoOffer = NoOfferWarning;
BaseWarning.OtherOffer = ChooseOtherOfferWarning;

export default BaseWarning;
